import SignIn from 'src/app/signin'
import LandingPage from 'src/app/landingPage'
import DashboardRoutes from 'src/app/dashboard/dashboard-routing'

export default [
    SignIn,
    LandingPage,
    DashboardRoutes
]